import { render } from "./jingle.vue?vue&type=template&id=15212b94&ts=true"
import script from "./jingle.vue?vue&type=script&lang=ts"
export * from "./jingle.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__